// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*{cursor:none!important}.cursor2{background-color:hsla(0,0%,78%,.188);border:1px solid hsla(0,0%,78%,.282);height:50px;margin:-25px;transition:.35s;width:50px;z-index:1000}.cursor,.cursor2{border-radius:50%;left:0;pointer-events:none;position:fixed;top:0}.cursor{background-color:#815ff6;height:8px;margin:-4px;width:8px;z-index:1001}@media (pointer:coarse){.cursor,.cursor2{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
